import { render, staticRenderFns } from "./UserSubscriptionHistory.vue?vue&type=template&id=20b0dd62"
import script from "./UserSubscriptionHistory.vue?vue&type=script&lang=ts"
export * from "./UserSubscriptionHistory.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports